import i18n from '../i18n/config';

/**
 * Utility function to get localized text from multilingual objects
 * @param text - Can be a string or an object with language keys (e.g., { fr: "...", en: "..." })
 * @param fallback - Fallback string if text is not available
 * @returns Localized string
 */
export const getLocalizedText = (text: any, fallback: string = ''): string => {
  if (typeof text === 'string') return text;
  if (typeof text !== 'object' || text === null || Array.isArray(text)) {
    return fallback;
  }

  const lang = i18n.language.split('-')[0] || 'fr';
  const candidates = [text[lang], text.fr, text.en, text.pt, ...Object.values(text)];
  const match = candidates.find((value) => typeof value === 'string');
  return match ?? fallback;
};

/** Locale BCP 47 pour formatage dates/nombres selon la langue UI. */
export const getDisplayLocale = (lang?: string): string => {
  const code = (lang || i18n.language || 'fr').split('-')[0].toLowerCase();
  if (code === 'fr') return 'fr-FR';
  if (code === 'pt') return 'pt-PT';
  return 'en-US';
};

/** Code langue UI/API (ex. fr-FR → fr) pour emails et requêtes backend. */
export const getActiveLanguageCode = (): string =>
  (i18n.language || 'fr').split('-')[0].toLowerCase();

